<!--宝记通用界面-->
<template>
  <div>
    <van-calendar
        :show-title="false"
        :poppable="false"
        :show-confirm="false"
        :style="{ height: '500px' }"
        :min-date="minDate"
        first-day-of-week="1"
        type="single"
        :formatter="formatter"
        :color="recColor"
        @select="selectDate"
    >
      <template slot="bottom-info" slot-scope="day">
        <van-icon :name="iconBottomType(day)" v-show="showBottomFlag(day)"/>
      </template>
    </van-calendar>
    <van-row type="flex" justify="end" style="margin-top: 30px">
      <van-col span="4">
        <van-icon name="add-o" size="25" color="#4fc08d" @click="confirmDate" v-show="!isSelect"/>
        <van-icon name="close" size="25" color="#ee0a24" @click="deleteDate" v-show="isSelect"/>
      </van-col>
    </van-row>
<!--    <van-button style="margin-top: 10px;" type="primary" size="small" v-show="!isSelect"-->
<!--                block round :color="recColor" :loading="isLoading"-->
<!--                loading-text="记录中..."-->
<!--                @click="confirmDate">记录</van-button>-->
<!--    <van-button style="margin-top: 10px;" type="danger" size="small" v-show="isSelect"-->
<!--                block round :loading="isDelLoading"-->
<!--                loading-text="删除中..."-->
<!--                @click="deleteDate">删除</van-button>-->
  </div>
</template>

<script>
import * as DateUtil from "../../common/utils/dateUtil";
import store from "@/store";
import * as BusiConsts from "@/common/BusiConsts";
import * as MyApi from "@/api/URLApiAddr";
import * as types from "@/common/types/mutation";
export default {
  name: "BaoCommRecord.vue",
  props:{
    recColor: String,
    recType: Number
  },
  data() {
    return {
      minDate: DateUtil.dayOfDateNum(-60),
      list:[{id:1,name:"pause-circle-o"}],
      isShow: false,
      isLoading: false,
      isDelLoading: false,
      selectToday: false,
      selectDay: '',
      isSelect: false,
      delDate: ''
    }
  },
  methods: {
    formatter(day) {
      const fullYear = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      if(month < 10){
        month = "0"+month;
      }
      let date = day.date.getDate();
      if(date < 10){
        date = "0" + date;
      }

      const thisDate = fullYear + "-" +month + "-" +date;

      //处理今日数据,如果没有选择当天则不进行颜色标注
      let recDate = DateUtil.formatDate(new Date,'yyyy-MM-dd')
      if(recDate == thisDate){
        if(!this.selectToday){
          day.type = "";
        }else{
          day.type = "selected";
        }
        day.text = '今日';
      }

      const baoRecords = store.state.busi.baoRecords;
      let tmpList = baoRecords[this.recType];
      let tmpInc = false;
      for(let i = 0 ; i < tmpList.length; i++) {
        let res = tmpList[i];
        //let split = res.split("-");
        if (thisDate == res.recDate) {
          //console.log(thisDate)
          if (BusiConsts.BAO_REC_FLAG_REALTIME == res.recFlag) {
            day.type = "selected";
          }
        }
        if(this.selectDay == res.recDate){
          tmpInc = true;
        }
      }
      //处理记录和删除按钮显示隐藏
      if(tmpInc){
        this.isSelect = true;
      }else{
        this.isSelect = false;
      }

      // 处理删除后的数据
      if(thisDate == this.delDate){
        day.type = ""
        this.delDate = ""
      }


      return day;
    },
    showFlag(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      if (month === 1) {
        if (date === 26 || date === 29) {
          return true;
        }
      }
      return false;
    },
    iconType(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      if (month === 1) {
        if (date === 26) {
          return "play-circle-o";
        }else if(date === 29){
          return "pause-circle-o";
        }
      }
      return "";
    },
    selectDate(date){
      let recDate = DateUtil.formatDate(date,'yyyy-MM-dd')
      let today = DateUtil.formatDate(new Date,'yyyy-MM-dd')
      this.selectDay = recDate
      if(recDate == today){
        this.selectToday = true;
      }else{
        this.selectToday = false;
      }

    },
    iconBottomType(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const thisDate = this.getCurrentDate(day);
      if(this.selectDay == thisDate){
        return "circle";
      }
      return "";
    },
    showBottomFlag(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const thisDate = this.getCurrentDate(day);
      if(this.selectDay == thisDate){
        return true;
      }
      return false;
    },
    confirmDate(){
      this.isLoading = true;
      let user = store.state.sys.user
      //params.userId = user.userId
      let recDate = this.selectDay

      let params = {userId:user.userId}
      params.recDate = recDate
      params.recType = this.recType
      params.recFlag = BusiConsts.BAO_REC_FLAG_REALTIME
      this.$axios.post(MyApi.SAVE_BAO_REC,params/*,options*/)

          // 请求成功后
          .then((resp) => {
            //let data = response.data;
            if('200' == resp.code){
              store.commit(types.BUSI+types.BAO_RECORDS_TYPE,resp.data);
              this.$toast.success(resp.msg);
            }
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$toast.fail("请求异常,请稍后再试");
          })
    },
    deleteDate(){
      this.isDelLoading = true;
      let user = store.state.sys.user
      //params.userId = user.userId
      let recDate = this.selectDay

      let params = {userId:user.userId}
      params.recDate = recDate
      params.recType = this.recType
      params.recFlag = BusiConsts.BAO_REC_FLAG_REALTIME
      this.$axios.post(MyApi.DEL_BAO_REC,params/*,options*/)

          // 请求成功后
          .then((resp) => {
            //let data = response.data;
            if('200' == resp.code){
              store.commit(types.BUSI+types.BAO_RECORDS_TYPE,resp.data);
              this.$toast.success(resp.msg);
            }
            this.delDate = this.selectDay
            this.isDelLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$toast.fail("请求异常,请稍后再试");
          })
    },
    getCurrentDate(day){
      const fullYear = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      if(month < 10){
        month = "0"+month;
      }
      let date = day.date.getDate();
      if(date < 10){
        date = "0" + date;
      }
      const thisDate = fullYear + "-" +month + "-" +date;
      return thisDate;
    }
  }
}
</script>

<style scoped>

</style>